module.exports = __webpack_public_path__ + "img/audio1.b66956a2.svg";